// extracted by mini-css-extract-plugin
export var blink = "_a2-2";
export var cursor = "_a2-1";
export var reactMarkdown = "_a2-3";
export var streamingText = "_a2-0";